import React, { useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Logs } from 'components/common/logs';
import { PERMISSIONS } from 'constants/permissions';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import './styles.scss';
import { Segmented } from 'antd';

type Align = `User Management` | `User's Actions`;
export const UserLogs = React.memo(() => {
  const { id } = useParams();
  const { hasAccess } = useAccessControl();
  const [alignValue, setAlignValue] = React.useState<Align>('User Management');

  const onChange = useCallback((key: Align) => {
    setAlignValue(key);
  }, []);

  const logOptions = useMemo(() => {
    const options = [];
    if (hasAccess(PERMISSIONS.users.management_logs.read)) {
      options.push(`User Management`);
    }
    if (hasAccess(PERMISSIONS.users.action_logs.read)) {
      options.push(`User's Actions`);
    }
    return options;
  }, [hasAccess]);

  return (
    <div className={'admin-logs'}>
      {logOptions.length ? (
        <>
          <Segmented
            value={alignValue}
            style={{ marginBottom: 32, width: 'max-content' }}
            onChange={onChange}
            options={logOptions as any}
          />
          <div className={'h-100'}>
            <Logs
              entityName={alignValue === `User's Actions` ? 'USER' : 'USER_MANAGEMENT'}
              service="uaa"
              isAdminLogs={alignValue === `User's Actions`}
              id={id}
            />
          </div>
        </>
      ) : (
        ''
      )}
    </div>
  );
});
